<template>
  <div class="addNew item">
    <ModalGlobal
      id="modalAddNewAlbum"
      class="modalAddNewAlbum"
      v-if="$store.state.componentes.modalAddNewAlbum"
      @close-modal="$store.dispatch('setModalAddAlbum', false)"
    >
      <template #dialogHeadImg>
        <img
          class="
            absolute
            h-22
            -top-12
            left-0
            right-0
            m-auto
            pointer-events-none
          "
          :src="$S3AssetUrl('suf/photopass-logo.png')"
          alt="logo photo"
        />
      </template>

      <AddParkHotel />

      <button
        @click="$store.dispatch('setModalAddAlbum', false)"
        type="button"
        class="
          w-full
          flex
          justify-center
          rounded-full
          py-3
          px-4
          mb-1
          mt-2
          border-newxcaret-red border
          bg-white
          cursor-pointer
          font-semibold
          mx-auto
        "
      >
        {{ $t("Forms.close") }}
      </button>
    </ModalGlobal>

    <div
      class="
        shadownBottom
        md:flex
        flex-row
        items-center
        justify-center
        relative
        cursor-pointer
        border-newxcaret-gray
        rounded-full
        px-4
        py-2
      "
      @click.prevent="$store.dispatch('setModalAddAlbum', true)"
    >
      <span class="font-bold mr-1">{{ $t("gallery.add_album") }}</span>
      <span class="albumes addcart material-icons"> add </span>
    </div>
  </div>
</template>


<script>
import AddParkHotel from "./forms/AddParkHotel.vue";

export default {
  props: [],
  mixins: [],
  components: {
    AddParkHotel,
  },
  data: () => ({
    modalAddNewAlbum: false,
  }),
  computed: {},
  methods: {},
  created() {

  },
  mounted() {
    this.$store.dispatch("setModalAddAlbum", false);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/variables.scss";

nav {
  background-color: black;

  .container {
    display: flex;

    justify-content: center;

    margin-left: auto;

    margin-right: auto;
  }

  .navbar-coupon {
    border: 1px solid #101010;

    background-color: $yellow-photo;

    padding: 0.25rem 1.6rem;

    border-radius: 20px;
  }
}

.navbar-logo {
  img {
    align-items: center;
  }

  span {
    padding-left: 0.5rem;

    font-size: 1.25rem;
  }
}
</style>